module.exports = __webpack_public_path__ + "img/Python-logo-notext.cab7d967.svg";